import { render, staticRenderFns } from "./PaidFlow.vue?vue&type=template&id=4a742fde&scoped=true&"
import script from "./PaidFlow.vue?vue&type=script&lang=js&"
export * from "./PaidFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a742fde",
  null
  
)

export default component.exports